export default __webpack_public_path__ + "static/media/bgslider.a29fc18c.png";